import fetchAPI from "./fetchAPI"

export async function addFlowerfield({ distances, contactInfo, token }) {
  const { addFlowerfield } = await fetchAPI(
    `mutation($distances: JSON!, $contactInfo: JSON!, $token: String!) {
          addFlowerfield(distances: $distances, contactInfo: $contactInfo, token: $token) {
            success
            message
            password
          }
        }`,
    {
      variables: {
        distances,
        contactInfo,
        token
      }
    }
  )

  return addFlowerfield
}

export async function updateFlowerfield({ distances, token }) {
  const { updateFlowerfield } = await fetchAPI(
    `mutation($distances: JSON!, $token: String!) {
          updateFlowerfield(distances: $distances, token: $token) {
            success
            message
            password
          }
        }`,
    {
      variables: {
        distances,
        token
      }
    }
  )

  return updateFlowerfield
}

export async function updateFlowerfieldContactInfo({ contactInfo, token }) {
  const { updateFlowerfieldContactInfo } = await fetchAPI(
    `mutation($contactInfo: JSON!, $token: String!) {
      updateFlowerfieldContactInfo(contactInfo: $contactInfo, token: $token) {
        success
      }
    }`,
    {
      variables: {
        contactInfo,
        token
      }
    }
  )

  return updateFlowerfieldContactInfo
}

export async function fetchFlowerfield(type, token) {
  const data = await fetchAPI(
    `query($type: String!, $token: String!) {
          fetchFlowerfield(type: $type, token: $token) {
            success,
            contactInfo,
            distances,
            token
          }
        }`,
    {
      variables: { type, token }
    },
    true
  )

  return data
}

export async function fetchAllFlowerfields() {
  const { fetchAllFlowerfields } = await fetchAPI(
    `query {
      fetchAllFlowerfields {
          data
        }
      }`,
    {},
    true
  )

  return fetchAllFlowerfields
}
